import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MainLayout } from "./components/Layout/MainLayout";
import Products from "./pages/Products";
import Areas from "./pages/Areas";
import { Login } from "./pages/Auth/Login";
import { ProtectedRoute } from "./components/Auth/ProtectedRoute";
import ApiKeys from "./pages/ApiKeys";
import Configs from "./pages/Configs";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/products" replace />} />
            <Route path="products" element={<Products />} />
            <Route path="areas" element={<Areas />} />
            <Route path="api-keys" element={<ApiKeys />} />
            <Route path="configs" element={<Configs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
